/* Publish by EComposer at 2025-08-08 13:17:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0or7dggy5hbk"]=  window.__ectimmers["ecom-0or7dggy5hbk"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-0or7dggy5hbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0or7dggy5hbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6ww2zxjn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6ww2zxjn9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7bhcmk04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bhcmk04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0coubx8uus1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0coubx8uus1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2q8ni5fuos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2q8ni5fuos', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxufm5zxmz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxufm5zxmz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sw2vjocvlz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sw2vjocvlz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tthve3k1if').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tthve3k1if', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlyoa6fd07g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlyoa6fd07g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptwtg4o9fq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptwtg4o9fq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-owd0kcpq74g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-owd0kcpq74g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fklz1o61c7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fklz1o61c7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dd9mhxo1ofk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dd9mhxo1ofk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q45rvkwp"]=  window.__ectimmers["ecom-q45rvkwp"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-q45rvkwp"]["9k8dzinze"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-q45rvkwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q45rvkwp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h05n7kijpmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h05n7kijpmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87hyy27473j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87hyy27473j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-inh9wem12w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-inh9wem12w', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b43dlts2ekd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b43dlts2ekd', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}